const router = {}

// 足球-联赛-赛程
const FootballLeagueScheduleIndex = () =>
  import(
    /* webpackChunkName: "footballLeagueScheduleIndex" */ '@platfrom/football/league_schedule/index.vue'
  )
// // 足球-联赛-赛程详情
// const FootballLeagueScheduleDetailIndex = () =>
//   import(
//     /* webpackChunkName: "footballLeagueScheduleDetailIndex" */ '@platfrom/basketball/league_scheduleDetail/index.vue'
//   )
// const FootballLeagueScheduleDetailPreMatch = () =>
//   import(
//     /* webpackChunkName: "footballLeagueScheduleDetailPreMatch" */ '@platfrom/basketball/league_scheduleDetail/childPage/preMatch.vue'
//   )

// const FootballLeagueScheduleDetailHotspots = () =>
//   import(
//     /* webpackChunkName: "footballLeagueScheduleDetailLineup" */ '@platfrom/basketball/league_scheduleDetail/childPage/hotspots.vue'
//   )

// const FootballLeagueScheduleDetailAnalysis = () =>
//   import(
//     /* webpackChunkName: "footballLeagueScheduleDetailAnalysis" */ '@platfrom/basketball/league_scheduleDetail/childPage/analysis.vue'
//   )

// const FootballLeagueScheduleDetailStatistics = () =>
//   import(
//     /* webpackChunkName: "footballLeagueScheduleDetailStatistics" */ '@platfrom/basketball/league_scheduleDetail/childPage/statistics.vue'
//   )

// 足球-联赛赛-赛程详情
const FootballLeagueScheduleDetailIndex = () =>
  import(
    /* webpackChunkName: "footballLeagueScheduleDetailIndex" */ '@platfrom/football/cup_scheduleDetail/index.vue'
  )
const FootballLeagueScheduleDetailPreMatch = () =>
  import(
    /* webpackChunkName: "footballLeagueScheduleDetailPreMatch" */ '@platfrom/football/cup_scheduleDetail/childPage/preMatch.vue'
  )

const FootballLeagueScheduleDetailLineup = () =>
  import(
    /* webpackChunkName: "footballLeagueScheduleDetailLineup" */ '@platfrom/football/cup_scheduleDetail/childPage/lineup.vue'
  )

const FootballLeagueScheduleDetailAnalysis = () =>
  import(
    /* webpackChunkName: "footballLeagueScheduleDetailAnalysis" */ '@platfrom/football/cup_scheduleDetail/childPage/analysis.vue'
  )

const FootballLeagueScheduleDetailStatistics = () =>
  import(
    /* webpackChunkName: "footballLeagueScheduleDetailStatistics" */ '@platfrom/football/cup_scheduleDetail/childPage/statistics.vue'
  )

// 足球-联赛-球队
const FootballLeagueTeamIndex = () =>
  import(
    /* webpackChunkName: "footballLeagueTeamListIndex" */ '@platfrom/basketball/league_team/index.vue'
  )

const FootballLeagueTeamRankIndex = () =>
  import(
    /* webpackChunkName: "footballLeagueTeamRankIndex" */ '@platfrom/basketball/league_teamRank/index.vue'
  )

// 足球-联赛-球队详情
const FootballLeagueTeamDetailIndex = () =>
  import(
    /* webpackChunkName: "footballLeagueTeamDetailIndex" */ '@platfrom/basketball/league_teamDetail/index.vue'
  )

const FootballLeagueTeamDetailPlayerList = () =>
  import(
    /* webpackChunkName: "footballLeagueTeamDetailPlayerList" */ '@platfrom/basketball/league_teamDetail/childPage/playerList.vue'
  )

const FootballLeagueTeamDetailTeamData = () =>
  import(
    /* webpackChunkName: "footballLeagueTeamDetailTeamData" */ '@platfrom/basketball/league_teamDetail/childPage/teamData.vue'
  )

const FootballLeagueTeamDetailMatchRecord = () =>
  import(
    /* webpackChunkName: "footballLeagueTeamDetailMatchRecord" */ '@platfrom/basketball/league_teamDetail/childPage/matchRecord.vue'
  )

const FootballLeagueTeamDetailMatchSchedule = () =>
  import(
    /* webpackChunkName: "footballLeagueTeamDetailMatchSchedule" */ '@platfrom/basketball/league_teamDetail/childPage/matchSchedule.vue'
  )

// 足球-联赛-数据
const FootballLeagueRecordDetailIndex = () =>
  import(
    /* webpackChunkName: "footballLeagueRecordDetailIndex" */ '@platfrom/basketball/league_record/index.vue'
  )

// 足球-联赛-数据-数据概览
const FootballLeagueRecordDetailDataOverview = () =>
  import(
    /* webpackChunkName: "footballLeagueRecordDetailDataOverview" */ '@platfrom/basketball/league_record/childPage/dataOverview.vue'
  )
// 足球-联赛-数据-球队数据
const FootballLeagueRecordDetailTeamData = () =>
  import(
    /* webpackChunkName: "footballLeagueRecordDetailTeamData" */ '@platfrom/basketball/league_record/childPage/teamData.vue'
  )
// 足球-联赛-数据-球员数据
const FootballLeagueRecordDetailPlayerData = () =>
  import(
    /* webpackChunkName: "footballLeagueRecordDetailPlayerData" */ '@platfrom/basketball/league_record/childPage/playerData.vue'
  )

// 足球-联赛-数据-阵容数据
const FootballLeagueRecordDetailLineupData = () =>
  import(
    /* webpackChunkName: "footballLeagueRecordDetailLineupData" */ '@platfrom/basketball/league_record/childPage/lineupData.vue'
  )

// 足球-联赛-球员
const FootballLeaguePlayerIndex = () =>
  import(
    /* webpackChunkName: "footballLeaguePlayerIndex" */ '@platfrom/basketball/league_player/index.vue'
  )

// 足球-联赛-球员详情
const FootballLeaguePlayerDetailIndex = () =>
  import(
    /* webpackChunkName: "footballLeaguePlayerDetailIndex" */ '@platfrom/basketball/league_playerDetail/index.vue'
  )

const FootballLeaguePlayerDetailSeasonData = () =>
  import(
    /* webpackChunkName: "footballLeaguePlayerDetailSeasonData" */ '@platfrom/basketball/league_playerDetail/childPage/seasonData.vue'
  )

const FootballLeaguePlayerDetailCareerData = () =>
  import(
    /* webpackChunkName: "footballLeaguePlayerDetailCareerData" */ '@platfrom/basketball/league_playerDetail/childPage/careerData.vue'
  )

const FootballLeaguePlayerDetailMatchRecord = () =>
  import(
    /* webpackChunkName: "footballLeaguePlayerDetailMatchRecord" */ '@platfrom/basketball/league_playerDetail/childPage/matchRecord.vue'
  )

// 足球-联赛-场馆
const FootballLeagueSportsHallIndex = () =>
  import(
    /* webpackChunkName: "footballLeagueSportsHallIndex" */ '@platfrom/basketball/league_sportsHall/index.vue'
  )

// 足球-联赛-播出单
const FootballLeagueBroadcastListIndex = () =>
  import(
    /* webpackChunkName: "commonPageBroadcastListIndex" */ '@platfrom/commonPage/broadcastList/index.vue'
  )

// 足球-联赛-数据包装
const FootballLeagueDataPackagListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageDataPackagListIndex" */ '@platfrom/commonPage/dataPackagList/index.vue'
  )

// 足球-联赛-节目单
const FootballLeagueProgramListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageProgramListIndex" */ '@platfrom/commonPage/programList/index.vue'
  )

router.FootballLeagueScheduleIndex = FootballLeagueScheduleIndex
router.FootballLeagueScheduleDetailIndex = FootballLeagueScheduleDetailIndex
router.FootballLeagueTeamRankIndex = FootballLeagueTeamRankIndex
router.FootballLeagueScheduleDetailPreMatch =
  FootballLeagueScheduleDetailPreMatch
router.FootballLeagueScheduleDetailLineup = FootballLeagueScheduleDetailLineup
router.FootballLeagueScheduleDetailAnalysis =
  FootballLeagueScheduleDetailAnalysis
router.FootballLeagueScheduleDetailStatistics =
  FootballLeagueScheduleDetailStatistics
router.FootballLeagueTeamIndex = FootballLeagueTeamIndex
router.FootballLeagueTeamDetailIndex = FootballLeagueTeamDetailIndex
router.FootballLeagueTeamDetailTeamData = FootballLeagueTeamDetailTeamData
router.FootballLeagueTeamDetailPlayerList = FootballLeagueTeamDetailPlayerList
router.FootballLeagueTeamDetailMatchRecord = FootballLeagueTeamDetailMatchRecord
router.FootballLeagueTeamDetailMatchSchedule =
  FootballLeagueTeamDetailMatchSchedule
router.FootballLeagueRecordDetailIndex = FootballLeagueRecordDetailIndex
router.FootballLeagueRecordDetailDataOverview =
  FootballLeagueRecordDetailDataOverview
router.FootballLeagueRecordDetailTeamData = FootballLeagueRecordDetailTeamData
router.FootballLeagueRecordDetailPlayerData =
  FootballLeagueRecordDetailPlayerData
router.FootballLeagueRecordDetailLineupData =
  FootballLeagueRecordDetailLineupData
router.FootballLeaguePlayerIndex = FootballLeaguePlayerIndex
router.FootballLeaguePlayerDetailIndex = FootballLeaguePlayerDetailIndex
router.FootballLeaguePlayerDetailSeasonData =
  FootballLeaguePlayerDetailSeasonData
router.FootballLeaguePlayerDetailCareerData =
  FootballLeaguePlayerDetailCareerData
router.FootballLeaguePlayerDetailMatchRecord =
  FootballLeaguePlayerDetailMatchRecord
router.FootballLeagueSportsHallIndex = FootballLeagueSportsHallIndex
router.FootballLeagueBroadcastListIndex = FootballLeagueBroadcastListIndex
router.FootballLeagueDataPackagListIndex = FootballLeagueDataPackagListIndex
router.FootballLeagueProgramListIndex = FootballLeagueProgramListIndex

export default router
